import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import alumniApi from "../../config/alumniApi";
import styles from "./AlumniPages.module.css";

const AlumniDashboard = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    alumniApi
      .get("/alumni/profile")
      .then(({ data }) => setProfile(data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <h1 className={styles.heading}>
        Welcome back{profile?.student_name ? `, ${profile.student_name}` : ""}
      </h1>
      <p className={styles.subheading}>Here's a quick look at your alumni profile.</p>

      {!loading && profile?.profile_completed_yn !== "Y" && (
        <div className={styles.panel} style={{ borderLeft: "4px solid #f79009" }}>
          <strong>Your profile is incomplete.</strong>
          <p style={{ margin: "6px 0 0", fontSize: 13.5, color: "#667085" }}>
            Add your current employment and location details so fellow alumni can find you
            in the directory.{" "}
            <Link to="/alumni/profile" style={{ color: "#1f3a6e" }}>Complete it now</Link>.
          </p>
        </div>
      )}

      <div className={styles.grid}>
        <div className={styles.statCard}>
          <div className={styles.statValue}>{profile?.cohort_name || "—"}</div>
          <div className={styles.statLabel}>Your Cohort</div>
        </div>
        <div className={styles.statCard}>
          <div className={styles.statValue}>{profile?.batch_name || "—"}</div>
          <div className={styles.statLabel}>Your Batch</div>
        </div>
        <div className={styles.statCard}>
          <div className={styles.statValue}>
            {profile?.employment_status ? profile.employment_status.replace("_", " ") : "—"}
          </div>
          <div className={styles.statLabel}>Employment Status</div>
        </div>
      </div>

      <div className={styles.panel}>
        <h3 style={{ marginTop: 0 }}>Quick links</h3>
        <div style={{ display: "flex", gap: 14, flexWrap: "wrap" }}>
          <Link to="/alumni/profile" className={styles.button} style={{ textDecoration: "none", display: "inline-block" }}>
            Update My Profile
          </Link>
          <Link to="/alumni/directory" className={styles.button} style={{ textDecoration: "none", display: "inline-block", background: "#1f3a6e" }}>
            Search Alumni Directory
          </Link>
          <Link to="/alumni/community" className={styles.button} style={{ textDecoration: "none", display: "inline-block", background: "#475467" }}>
            Community Links
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AlumniDashboard;
